import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
} from "@mui/material";

import { useQuery } from "@apollo/client";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { RiFilePaper2Fill } from "react-icons/ri";

//Srcs
import "../../../Style/pagestyle.scss";
import { GET_ADJ_OUT_PAGINATOR } from "../../../Schema/Ajustment";
import { AuthContext } from "../../../Context/AuthContext";
import CreateIcon from "../../../Assets/create-icon.svg";
import EmptyData from "../../Include/EmptyData";
import FooterPagination from "../../Include/FooterPagination";
import LoadingPage from "../../Include/LoadingPage";
import { SelectSupplier } from "../../Include/DynamicSelect";
import { SelectWarehouse } from "../../Include/DynamicSelect";
import CreateAdjustOut from "./CreateAdjustOut";
import AdjustOutAction from "./AdjustOutAction";

export default function AdjustOutPage() {

  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState();
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [getAdjOutDate, setGetAdjOutDate] = useState();
  const [selectWarehouse, setSelectedWarehouse] = useState({
    id: "",
    title: "",
  });

  const { refetch } = useQuery(GET_ADJ_OUT_PAGINATOR, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      date: getAdjOutDate ? moment(getAdjOutDate).format("YYYY-MM-DD") : null,
      warehouseId: selectWarehouse?.id,
    },
    onCompleted: ({ getAdjustOutPagination }) => {
      console.log("getAdjustOutPagination+;;;", getAdjustOutPagination)
      setTableData(getAdjustOutPagination?.data);
      setPaginationData(getAdjustOutPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      // console.log("Error::", err?.message);
    },
  });
  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };
  //width
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 2000);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);



  //open Create
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // console.log("tableData:::", tableData);
  // console.log("selectWarehouse?.id:::", selectWarehouse?.id);

  const handleTranslate = (value) => {
    if (value === "lose") {
      return "បាត់";
    } else if (value === "broken") {
      return "ខូច";
    } else if (value === "to_use") {
      return "ប្រើប្រាស់";
    } else if (value === "excess") {
      return "លើស";
    } else {
      return value
    }
  }

  return (
    <div className="page-container">
      <Box sx={{ marginTop: "5px" }}>
        <Stack direction="row" marginTop={"-9px"} marginX={"-24px"}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="header-text">
                ស្វែងរកឃ្លាំងទំនិញ
              </Typography>
              <SelectWarehouse
                className="search-field"
                selectedVal={selectWarehouse}
                setSelectedVal={setSelectedWarehouse}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="header-text">កាលបរិច្ចេទ</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={getAdjOutDate}
                  onChange={(newValue) => {
                    setGetAdjOutDate(newValue);
                  }}
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                    },
                  }}
                  className="search-field"
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={6} xl={7.2}>
              <Stack direction="row" justifyContent="right">
                <Button
                  onClick={handleOpen}
                  className="btn-create"
                  startIcon={
                    <img
                      src={CreateIcon}
                      alt="CreateIcon"
                      className="icon-add"
                    />
                  }
                >
                  បង្កើត
                </Button>
                {open && (
                  <CreateAdjustOut
                    open={open}
                    handleClose={handleClose}
                    setRefetch={refetch}
                  />
                )}
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Box>

      <Box className="body-container" marginTop="30px">
        <Stack direction="row" marginTop={"-9px"} marginX={"-24px"}>
          <TableContainer sx={{ maxWidth: `${width}px` }}>
            <Table className="table" aria-label="simple table">
              <TableHead className="header-row ">
                <TableCell className="header-title-start" width="6%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title" width="20%">
                  កាលបរិច្ចេទដកស្តុក
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ឃ្លាំងទំនិញ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  មូលហេតុ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  បង្កើតដោយ
                </TableCell>
                {/* <TableCell className="header-title" width="15%">
                  ចំនួន
                </TableCell> */}
                <TableCell className="header-title" width="15%">
                  ចំណាំ
                </TableCell>
                <TableCell
                  className="header-title-end"
                  width="17%"
                  align="center"
                >
                  ពិនិត្យ
                </TableCell>
              </TableHead>
              {loading ? (
                <LoadingPage colSpan={7} />
              ) : (
                <>
                  {tableData?.length === 0 ? (
                    <EmptyData colSpan={7} />
                  ) : (
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.dateTime)?.format(
                                "DD-MM-YYYY hh:mm a"
                              )}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.warehouseId?.warehouseName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {handleTranslate(row?.reason)}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.createdBy?.mainUserId?.lastName}{" "}{row?.createdBy?.mainUserId?.firstName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.remark}
                            </TableCell>
                            <TableCell className="body-cell-end" align="center">
                              <AdjustOutAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                </>
              )}
            </Table>
          </TableContainer>
        </Stack>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
      </Box>
    </div>
  );
}
